.animatedSearch {
  display: block;
  position: fixed;
  inset: 0;
  height: 100%;
  background-color: var(--primitives-colors-neutral-990);

  .globalSearch {
    height: 100%;
  }

  .searchInput {
    padding: 24px 16px;
  }

  &.animatedSearchOpened {
    animation: drop-on 0.3s linear;
  }

  &.animatedSearchClosed {
    animation: drop-off 0.3s linear;
  }

  .searchPopup {
    position: absolute;
    width: 100%;
    background: var(--primitives-colors-neutral-990);

    @media (orientation:landscape) and (max-width: 1024px) {
      left: 50%;
      transform: translateX(-50%);
      top: 72px;
    }
  }
}

@keyframes drop-on {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(0);
  }
}

@keyframes drop-off {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(100%);
  }
}